import en from '../languages/en.json';
import de from '../languages/de.json';
import it from '../languages/it.json';
import es from '../languages/es.json';
import cz from '../languages/cz.json';
import pl from '../languages/pl.json';
import hu from '../languages/hu.json';

export const translations = {
  en,
  de,
  it,
  es,
  cz,
  pl,
  hu,
};



// WEBPACK FOOTER //
// ./src/core/translations.js